import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Router } from "@angular/router";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-time-slot-settings",
  templateUrl: "./time-slot-settings.component.html",
  styleUrls: ["./time-slot-settings.component.scss"],
})
export class TimeSlotSettingsComponent implements OnInit {
  equipmentList: any;
  tcInsuranceList: any;
  eq: any;
  i: any;
  alert: any;
  generalvalidationMessage: any;
  haveChanges = false;
  submitted = false;
  showError = false;
  selectedlang: any = [];
  Message: any;
  equList: any = [];
  validData = false;
  saveBoolean = false;
  errorMessage: string;

  updateobj = false;
  z;
  on = false;
  off = false;
  type: any;
  selected = false;
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  CountryId: any;
  warningMessage =
    "Turning off the Insurance Accepted feature will allow you to accept all insurance and not just the once listed in your Insurance module.";

  @ViewChild("generalvalidation") generalvalidation: TemplateRef<any>;
  @ViewChild("insuranceoff") insuranceoff: TemplateRef<any>;
  @ViewChild("popopen") popopen: TemplateRef<any>;

  constructor(
    private appservice: AppService,
    private router: Router,
    private modalService: BsModalService,
    private supportService: SupportService
  ) {}

  ngOnInit() {
    if (localStorage.getItem("countryId") != null) {
      this.CountryId = localStorage.getItem("countryId");
    }
    this.viewTestCenter();
    this.getallequipments();
    this.getLanguage();
    if (localStorage.getItem("testCenterName") != null) {
      this.supportService.testCenterName.next(
        localStorage.getItem("testCenterName")
      );
    }

    if (localStorage.getItem("stateName") != null) {
      this.supportService.stateName.next(localStorage.getItem("stateName"));
    }

    this.viewTCinsurance();
  }

  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res && res["commonMsg"]) {
        this.selectedlang = res["commonMsg"];
      }
    });
  }
  getallequipments() {
    const data = {
      testCenterId: localStorage.getItem("testCenterId"),
    };

    this.appservice.getAllEquipmentsByTc(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.equipmentList = res["entity"];
          if (this.equipmentList && this.equipmentList.length > 0) {
            this.showError = false;
            for (let index = 0; index < this.equipmentList.length; index++) {
              this.equipmentList[index].daysValid = false;
              this.equipmentList[index].weeksValid = false;
              this.equipmentList[index].weekHour = this.getHoursFormate(
                this.equipmentList[index].weekHours
              );
              this.equipmentList[index].dayHour = this.getHoursFormate(
                this.equipmentList[index].dayHours
              );
            }
          } else {
            this.showError = true;
          }
        } else {
          this.showError = true;
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getHoursFormate(num) {
    var hours = Math.floor(num / 60);
    var minutes = num % 60;
    if (minutes > 0) {
      return hours + ":" + minutes;
    } else {
      return hours;
    }
  }

  changeInsuranceType(type, i) {
    this.updateobj = true;
    this.tcInsuranceList[i].type = type;
  }

  saveTimeslot() {
    this.validData = false;
    this.equList = [];
    for (let index = 0; index < this.equipmentList.length; index++) {
      if (
        this.equipmentList[index].weekHours &&
        this.equipmentList[index].weekHours !== "" &&
        this.equipmentList[index].weekHours !== "0" &&
        this.equipmentList[index].weekHours !== " " &&
        +this.equipmentList[index].weekHours > 0
      ) {
        this.equipmentList[index].weeksValid = false;
        this.saveBoolean = false;
      } else {
        this.equipmentList[index].weeksValid = true;
      }
      if (
        this.equipmentList[index].dayHours &&
        this.equipmentList[index].dayHours !== "" &&
        this.equipmentList[index].dayHours !== "0" &&
        this.equipmentList[index].dayHours !== " " &&
        +this.equipmentList[index].dayHours > 0
      ) {
        this.equipmentList[index].daysValid = false;
        this.saveBoolean = false;
      } else {
        this.equipmentList[index].daysValid = true;
      }
      if (
        !this.equipmentList[index].daysValid &&
        !this.equipmentList[index].weeksValid
      ) {
        const eq = {
          id: this.equipmentList[index].id,
          weekHours: this.equipmentList[index].weekHours,
          dayHours: this.equipmentList[index].dayHours,
          available: this.equipmentList[index].available,
        };
        this.equList.push(eq);
      } else {
        this.validData = true;
      }
    }

    if (this.validData === true) {
      this.saveBoolean = false;
      this.submitted = true;
      this.haveChanges = true;
    }
    if (!this.haveChanges) {
      this.alert = this.selectedlang.alert;
      this.generalvalidationMessage = this.selectedlang.noChangetc;
      this.openModal(this.generalvalidation);
      return;
    }

    if (this.validData === false) {
      this.saveBoolean = true;
      const data = {
        businessHour: true,
        procedureDuration: true,
        technicianAvailability: true,
        insuranceAccepted: this.on,
        tcEquipment: this.equList,
      };

      this.appservice.tctimeslotupdate(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.submitted = false;
            this.saveBoolean = false;
            this.Message = this.selectedlang.tcUpdated;
          }
          if (res && res["status"] && res["status"]["status"] === 204) {
            this.submitted = false;
            this.saveBoolean = false;
            this.Message = "";
            this.errorMessage = this.selectedlang.norec;
          }
          setTimeout(() => {
            this.Message = "";
          }, 5000);
          this.getallequipments();
          this.viewTestCenter();
        },
        (err) => {
          this.appservice.sessionOut(err);
          this.saveBoolean = false;
        }
      );
      this.haveChanges = false;
    }
  }

  gotoInsurance() {
    this.selected = false;
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "insurance",
    ]);
  }
  changesAvailable(type, index) {
    this.haveChanges = true;
    if (type === "d") {
      if (this.equipmentList[index].dayHours === "") {
        this.haveChanges = true;
        this.equipmentList[index].daysValid = true;
      } else {
        this.equipmentList[index].daysValid = false;
      }
    }
    if (type === "w") {
      if (this.equipmentList[index].weekHours === "") {
        this.haveChanges = true;
        console.log("empty3");
        this.equipmentList[index].weeksValid = true;
      } else {
        this.equipmentList[index].weeksValid = false;
      }
    }
  }


  changeInsuranceAcceptance(){
    var data ={
      testcenterid: localStorage.getItem("testCenterId"),
      acceptance: this.on
    }
    this.appservice.acceptInsurance(data).subscribe(res=>{
      console.log(res);
    })
  }

  changeinsaccepted(value) {
    this.haveChanges = true;
    if (value === true) {
      this.on = true;
      this.changeInsuranceAcceptance();
    } else {
      this.on = false;
      this.alert = this.selectedlang.alert;
      this.generalvalidationMessage = this.selectedlang.insuranceOff;
      this.openModal(this.insuranceoff);
    }
  }

  insOn(){
    this.changeInsuranceAcceptance();
    this.modalRef.hide();
  }

  insOff() {
    this.on = true;
    this.modalRef.hide();
  }

  viewTCinsurance() {
    const data = {
      testcenterid: localStorage.getItem("testCenterId"),
    };

    this.appservice.viewTCinsurance(data).subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"]["status"] &&
          res["status"]["status"] === 200
        ) {
          this.tcInsuranceList = res["entity"];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  listInsurance() {
    this.modalRef = this.modalService.show(
      this.popopen,
      Object.assign({ class: "modal-lg" })
    );
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  changeAvailability(value, eq) {
    this.haveChanges = true;
    if (value === true) {
      eq.available = true;
    } else {
      eq.available = false;
    }
  }
  viewTestCenter() {
    this.appservice.viewtestcenter().subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"] &&
          res["status"]["status"] === 200
        ) {
          if (res["entity"]) {
            localStorage.setItem("testCenterId", res["entity"]["id"]);
            if (res["entity"]["insuranceAccepted"] === true) {
              this.on = true;
            } else {
              this.on = false;
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }
}
